import { useMemo, useRef, useState } from 'react';

// Versione di ogni riga come l'operatore l'ha vista l'ULTIMA VOLTA IN MODO ESPLICITO (apertura della pagina, cambio di mese o filtri,
// dopo un salvataggio, una eliminazione o un conflitto). L'aggiornamento periodico (ogni 10 secondi e al ritorno sulla scheda o sulla finestra del browser)
// cambia ciò che si vede ma NON questa versione: le azioni distruttive (eliminare) mandano la versione "vista", così una riga modificata da
// un altro mentre si era altrove risponde 409 invece di sparire, e la riga cambiata si segnala ("modificata da altri") finché non la si
// riconosce o si ricarica.
export default function useVersioniViste() {
  const mappa = useRef(new Map());
  const [, ridisegna] = useState(0);
  return useMemo(() => ({
    // `silenzioso`: caricamento periodico, non cambia le versioni già viste (le righe nuove sì, partono dalla versione attuale)
    aggiorna(righe, { silenzioso = false } = {}) {
      const m = mappa.current;
      const presenti = new Set(righe.map(r => r.id));
      for (const id of [...m.keys()]) if (!presenti.has(id)) m.delete(id);
      for (const r of righe) if (!silenzioso || !m.has(r.id)) m.set(r.id, r.version);
    },
    versioneVista: (riga) => (mappa.current.has(riga.id) ? mappa.current.get(riga.id) : riga.version),
    cambiata: (riga) => mappa.current.has(riga.id) && mappa.current.get(riga.id) !== riga.version,
    riconosci(riga) { mappa.current.set(riga.id, riga.version); ridisegna(n => n + 1); },
  }), []);
}
